export const ADMIN_ROUTE_BY_KEY: Record<string, string> = {
  dashboard: "/admin/dashboard",
  blog: "/admin/blogs",
  artical: "/admin/articles",
  success: "/admin/success-stories",
  events: "/admin/events",
  courses: "/admin/courses",
  home: "/admin/home-content",
  "corporate-training": "/admin/corporate-training",
  "student-testimonial": "/admin/student-testimonials",
  trainer: "/admin/trainers",
  users: "/admin/users",
  audience: "/admin/audience",
  job: "/admin/jobs",
  builder: "/admin/builders",
  MarketAnalaysis: "/admin/market-analysis",
  developers: "/admin/developers",
  projects: "/admin/projects",
  keyword: "/admin/metadata",
  settings: "/admin/settings",
};

export const ADMIN_KEY_BY_ROUTE = Object.fromEntries(
  Object.entries(ADMIN_ROUTE_BY_KEY).map(([key, path]) => [path, key])
) as Record<string, string>;

export const DEFAULT_ADMIN_ROUTE = ADMIN_ROUTE_BY_KEY.dashboard;

